import type { Comment } from "./contracts";
import { newIdempotencyKey, request } from "./transport";

export async function listComments(boardId: string, ticketId: string): Promise<Comment[]> {
  const items: Comment[] = [];
  let cursor: string | null = null;
  do {
    const query = new URLSearchParams({ limit: "200" });
    if (cursor) query.set("cursor", cursor);
    const page = (
      await request<{ items: Comment[]; next_cursor: string | null }>(
        "GET",
        `/api/v1/boards/${boardId}/tickets/${ticketId}/comments?${query.toString()}`,
      )
    ).body;
    items.push(...page.items);
    cursor = page.next_cursor;
  } while (cursor);
  return items;
}

export async function createComment(
  boardId: string,
  ticketId: string,
  body: string,
): Promise<Comment> {
  return (
    await request<Comment>(
      "POST",
      `/api/v1/boards/${boardId}/tickets/${ticketId}/comments`,
      { body },
      { idempotencyKey: newIdempotencyKey() },
    )
  ).body;
}

export async function updateComment(
  boardId: string,
  ticketId: string,
  comment: Comment,
  body: string,
): Promise<Comment> {
  return (
    await request<Comment>(
      "PATCH",
      `/api/v1/boards/${boardId}/tickets/${ticketId}/comments/${comment.id}`,
      { body },
      { etag: comment.version },
    )
  ).body;
}

export async function deleteComment(
  boardId: string,
  ticketId: string,
  comment: Comment,
): Promise<void> {
  await request<void>(
    "DELETE",
    `/api/v1/boards/${boardId}/tickets/${ticketId}/comments/${comment.id}`,
    undefined,
    { etag: comment.version },
  );
}
